//Libraries
import React, { useState, useEffect, useRef } from "react";
import Link from "next/link";
import { useUser } from "@auth0/nextjs-auth0";
import { useRouter } from "next/router";

//Components
import Header from "../components/Header";
import Footer from "../components/Footer";

//Services
import { getCategories } from "../services/catalogsService";
import { AW_LOGIN_URL } from "../services/awAuth";

export default function Example({ categories }) {
  const { user, error, isLoading } = useUser();
  const router = useRouter();
  const videoRef = useRef(null);
  const [isPageLoaded, setIsPageLoaded] = useState(false);

  const [searchValue, setSearchValue] = useState("");

  const [popularCategories, setPopularCategories] = useState(categories.slice(0, 10));
  const [toggleViewMoreCategories, setToggleViewMoreCategories] = useState(false);

  const handleSerachValue = () => {
    setSearchValue(event.target.value);
  };

  const handleToggleViewMoreCategories = () => {
    if (!toggleViewMoreCategories) {
      setPopularCategories(categories ? categories : []);
      setToggleViewMoreCategories(true);
    } else {
      setPopularCategories(categories ? categories.slice(0, 10) : []);
      setToggleViewMoreCategories(false);
    }
  };

  useEffect(() => {
    // Marcar la página como cargada cuando el componente se monte
    setIsPageLoaded(true);

    // Reproducir el video cuando la página esté cargada
    if (isPageLoaded && videoRef.current) {
      videoRef.current.play().catch((error) => {
        console.error("Error al reproducir el video:", error);
      });
    }
  }, [isPageLoaded]);

  return (
    <div className="bg-white pt-20">
      {/* Menu */}
      <Header user={user} />

      <main
        onClick={() => {
          if (!user) router.push(AW_LOGIN_URL);
        }}
        className={!user ? "cursor-pointer" : ""}
      >
        {/* Hero section */}
        <div className="relative h-screen-75">
          <div className="relative h-full bg-gold-600 sm:h-full md:absolute md:right-0 md:h-full md:w-1/2">
            <video ref={videoRef} className="w-full h-full object-cover" muted loop playsInline>
              <source src="/videos/aw-animate-full.mp4" type="video/mp4" />
              Your browser does not support the video tag.
            </video>
            <div aria-hidden="true" className="absolute inset-0 bg-gradient-to-r from-teal-500 to-cyan-600 mix-blend-multiply" />
          </div>
          <div className="relative h-full mx-auto max-w-md px-4 py-12 sm:max-w-6xl sm:px-1 sm:py-20 md:py-28 lg:px-2 lg:py-32">
            <div className="h-100 mr-auto w-1/2 pr-10">
              <div className="mt-2 text-gindo text-2xl font-bold tracking-tight leading-tight text-center">
                <p className="text-3xl lg:text-4xl 2xl:text-5xl">Where Art</p>
                <p className="text-3xl lg:text-4xl 2xl:text-5xl">meets your Senses</p>
              </div>
              <p className="mt-8 text-xl lg:text-2xl text-rojo font-medium tracking-tight leading-tight text-center">A place where artists have the opportunity to shine and show the world their talents.</p>
              <div className="mt-16"></div>
              <div className="mt-20">
                <div className="grid grid-flow-col grid-cols-2 grid-rows-1 gap-4 text-sm">
                  <div>
                    <p className="font-bold text-center text-rojo">Over 30 categories to search after</p>
                    <p className="text-gindo text-center">Dance, Sing, ArtCrafts, Actors, Sculptures, Clothing and More</p>
                  </div>
                  <div>
                    <p className="font-bold text-center text-rojo">Join the hundred of people</p>
                    <p className="text-gindo text-center">Be creative, Be smart, Be better.</p>
                  </div>
                </div>
              </div>
            </div>
          </div>
        </div>

        {/* Logo Sponsors */}

        {/*
        <div>
          <div className="max-w-7xl mx-auto py-14 px-4 sm:px-6 lg:px-8">
            <div className="mt-8 grid grid-cols-4 sm:grid-cols-1 lg:grid-cols-4">
              <div className="col-span-1 flex justify-center md:col-span-2 lg:col-span-1">
                <div className="text-center">
                  <p className="text-4xl text-rojo font-bold">153</p>
                  <p className="font-sm text-gindo">Trusted Artists in different Categories</p>
                </div>
              </div>
              <div className="col-span-1 flex justify-center md:col-span-2 lg:col-span-1">
                <div className="text-center">
                  <p className="text-4xl text-rojo font-bold">1,472</p>
                  <p className="font-sm text-gindo">Happy clients</p>
                </div>
              </div>
              <div className="col-span-1 flex justify-center md:col-span-2 lg:col-span-1">
                <div className="text-center">
                  <p className="text-4xl text-rojo font-bold">18</p>
                  <p className="font-sm text-gindo">Countries</p>
                </div>
              </div>
              <div className="col-span-1 flex justify-center md:col-span-2 lg:col-span-1">
                <div className="text-center">
                  <p className="text-4xl text-rojo font-bold">3,478</p>
                  <p className="font-sm text-gindo">Different Services/Products</p>
                </div>
              </div>
            </div>
            {/* <div className="mt-16 grid grid-cols-5 md:grid-cols-1 lg:grid-cols-5">
              <div className="col-span-1 flex justify-center md:col-span-2 lg:col-span-1">
                <img className="h-12" src="https://tailwindui.com/img/logos/statickit-logo-gray-400.svg" alt="StaticKit" />
              </div>
              <div className="col-span-1 flex justify-center md:col-span-2 md:col-start-2 lg:col-span-1">
                <img className="h-12" src="https://tailwindui.com/img/logos/transistor-logo-gray-400.svg" alt="Transistor" />
              </div>
              <div className="col-span-1 flex justify-center md:col-span-2 md:col-start-4 lg:col-span-1">
                <img className="h-12" src="https://tailwindui.com/img/logos/workcation-logo-gray-400.svg" alt="Workcation" />
              </div>
              <div className="col-span-1 flex justify-center md:col-span-2 md:col-start-4 lg:col-span-1">
                <img className="h-12" src="https://tailwindui.com/img/logos/mirage-logo-gray-400.svg" alt="Workcation" />
              </div>
              <div className="col-span-1 flex justify-center md:col-span-2 md:col-start-4 lg:col-span-1">
                <img className="h-12" src="https://tailwindui.com/img/logos/tuple-logo-gray-400.svg" alt="Workcation" />
              </div>
            </div> */}
        {/*
          </div>
        </div>*/}

        {/* Guest Call to Action */}
        <div className="relative pt-16 pb-32 overflow-hidden bg-about-guest bg-cover">
          <div aria-hidden="true" className="absolute inset-x-0 top-0 h-48" />
          <div className="relative">
            <div className="lg:mx-auto lg:max-w-7xl lg:px-8 lg:grid lg:grid-cols-2 lg:grid-flow-col-dense lg:gap-24">
              <div className="px-4 max-w-xl mx-auto sm:px-6 lg:py-16 lg:max-w-none lg:mx-0 lg:px-0">
                <div>
                  <div className="mt-6">
                    <h2 className="text-4xl font-bold tracking-tight leading-tight text-white">The First International Networking for Artists</h2>
                    <p className="mt-4 text-base text-white">Where you can get in touch with artists, hire them for their services, learn directly from the masters and buy artcrafts</p>
                    <div className="mt-6">
                      {!user ? (
                        <a href="/" className="inline-flex px-8 py-4 border border-transparent text-base font-medium rounded-md shadow-sm text-white bg-gradient-to-r from-gold-600 to-gold-600 hover:from-gold-700 hover:to-gold-700">
                          Look as a Guest
                        </a>
                      ) : (
                        <a href="/discovery" className="inline-flex px-8 py-4 border border-transparent text-base font-medium rounded-md shadow-sm text-white bg-gradient-to-r from-gold-600 to-gold-600 hover:from-gold-700 hover:to-gold-700">
                          Start Browsing
                        </a>
                      )}
                    </div>
                  </div>
                </div>
              </div>
            </div>
          </div>
        </div>

        {/* Categories */}
        <div className="my-8 relative bg-white">
          <div className="max-w-4xl mx-auto px-4 py-16 text-center sm:px-6 sm:pt-20 sm:pb-24 lg:max-w-7xl lg:pt-24 lg:px-8">
            <h2 className="text-3xl font-extrabold text-rojo tracking-tight">Our Categories</h2>
            <div className="mt-12">
              <ul role="list" className="grid grid-cols-2 gap-x-4 gap-y-8 sm:grid-cols-3 sm:gap-x-8 lg:grid-cols-5 xl:gap-x-12">
                {popularCategories.map((category) => (
                  <li key={category.name} className="relative">
                    <Link href={`./discovery?category=${category._id}`}>
                      <div className="group block w-full aspect-w-10 aspect-h-7 rounded-lg bg-gray-100 focus-within:ring-2 focus-within:ring-offset-2 focus-within:ring-offset-gray-100 focus-within:ring-gindo-500 overflow-hidden cursor-pointer">
                        <img src={category.image_url} alt="" className="object-cover pointer-events-none group-hover:opacity-75" />
                        <button type="button" className="absolute inset-0 focus:outline-none">
                          <span className="sr-only">View details for {category.name}</span>
                        </button>
                      </div>
                    </Link>
                    <p className="mt-2 block text-sm font-medium text-gray-900 truncate pointer-events-none">{category.name}</p>
                  </li>
                ))}
                {/* View more */}
                {popularCategories && popularCategories.length > 10 && (
                  <li key="viewmore" className="relative">
                    <div className="flex h-full">
                      <div className="m-auto">
                        {user ? (
                          <Link href="/contact-us">
                            <span className="text-gold text-lg font-bold underline cursor-pointer">Get in touch</span>
                          </Link>
                        ) : (
                          <Link href="/">
                            <span className="text-gold text-lg font-bold underline cursor-pointer">View more</span>
                          </Link>
                        )}
                      </div>
                    </div>
                  </li>
                )}
              </ul>
            </div>
            <a className="mt-12 w-full inline-flex items-center justify-center px-5 py-3 border border-transparent text-base font-medium rounded-md text-white bg-gold-600 hover:bg-gold-700 sm:w-auto cursor-pointer" onClick={() => handleToggleViewMoreCategories()}>
              More categories
            </a>
          </div>
        </div>

        {/* CTA Section */}
        <div className="bg-gray-50">
          <div className="max-w-4xl mx-auto py-16 px-4 sm:px-6 sm:py-24 lg:max-w-7xl lg:px-80 text-center">
            <h2 className="text-4xl font-extrabold tracking-tight text-gray-900 sm:text-4xl">
              <span className="block text-gindo">
                <a className="text-rojo">Join now</a> and start learning, experiencing and enjoying.
              </span>
            </h2>
            {!user ? (
              <a href={AW_LOGIN_URL} className="mt-12 w-full inline-flex items-center justify-center px-5 py-3 border border-transparent text-base font-medium rounded-md text-white bg-gold-600 hover:bg-gold-700 sm:w-auto">
                Sign Up Now
              </a>
            ) : (
              <a href="/discovery" className="mt-12 w-full inline-flex items-center justify-center px-5 py-3 border border-transparent text-base font-medium rounded-md text-white bg-gold-600 hover:bg-gold-700 sm:w-auto">
                Discover more
              </a>
            )}
          </div>
        </div>
      </main>

      {/* Footer */}
      <Footer />
    </div>
  );
}

export async function getStaticProps() {
  const categories = await getCategories();

  return {
    props: {
      categories,
    },
  };
}
